export default __webpack_public_path__ + "static/media/logo.2cd4e632.png";